module.exports = __webpack_public_path__ + "img/icon_sgkbz.03323070.png";